var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebookIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 33,
    width: 33,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 33 33",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Facebook") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17 33a16 16 0 1116-16 16 16 0 01-16 16z",
    fill: "#ffc212"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.49 17.08v9.27a.24.24 0 00.24.24h3.45a.24.24 0 00.24-.24v-9.43h2.49a.23.23 0 00.24-.22l.25-2.84a.24.24 0 00-.25-.26h-2.73v-2a.86.86 0 01.85-.86h1.93a.24.24 0 00.24-.24V7.65a.24.24 0 00-.24-.24H18a3.46 3.46 0 00-3.46 3.45v2.74h-1.77a.24.24 0 00-.24.24v2.84a.24.24 0 00.24.24h1.72z",
    fill: "#28414b",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookIcon);
export default __webpack_public_path__ + "static/media/facebook_icon.b1c7a9155a89cc06542ceca64c2ea24f.svg";
export { ForwardRef as ReactComponent };